<template>
  <div class="lift-step-six">
    <v-switch
      v-model="form.breastplate_module.idc_breastplate"
      hide-details
      label="Plastron :"
      class="title"
      @change="clearBreastplateFields"
    />
    <v-layout>
      <v-flex sm4>
        <v-radio-group
          v-model="form.breastplate_module.breastplate_type"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        >
          <v-layout
            class="checkbox-input-container mb-4"
            align-center
          >
            <v-flex sm6>
              <v-radio
                label="Plastron"
                value="BREASTPLATE"
                :disabled="!form.breastplate_module.idc_breastplate"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.breastplate_module.breastplate"
                :items="breastPlateModule.breasplate"
                item-text="label"
                item-value="value"
                filled
                hide-details
                :disabled="!form.breastplate_module.idc_breastplate"
                @click:clear="
                  $nextTick(() => (form.breastplate_module.breastplate = null))
                "
              />
            </v-flex>
          </v-layout>
          <v-layout
            class="checkbox-input-container"
            align-center
          >
            <v-flex sm6>
              <v-radio
                label="Boléro"
                value="BOLERO"
                :disabled="!form.breastplate_module.idc_breastplate"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            >
              <v-select
                v-model="form.breastplate_module.size"
                :items="breastPlateModule.size"
                item-text="label"
                item-value="value"
                filled
                hide-details
                :disabled="!form.breastplate_module.idc_breastplate"
                @click:clear="
                  $nextTick(() => (form.breastplate_module.size = null))
                "
              />
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
      <v-flex sm5>
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_otn_1a.svg">
            <v-text-field
              v-model="form.breastplate_module.a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schema A"
              :class="{ error: errors.has('(Plastron) Schema A') }"
              type="number"
              style="top: 20.1%;left: 32.8%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
              outlined
            />
            <v-text-field
              v-model="form.breastplate_module.a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schema A"
              :class="{ error: errors.has('(Plastron) Schema A') }"
              type="number"
              style="top: 20.1%;left: 80.4%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
              outlined
            />
            <v-text-field
              v-model="form.breastplate_module.b"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schema B"
              :class="{ error: errors.has('(Plastron) Schema B') }"
              type="number"
              style="top: 3%;left: 56.9%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
              outlined
            />
            <v-text-field
              v-model="form.breastplate_module.c"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schema C"
              :class="{ error: errors.has('(Plastron) Schema C') }"
              type="number"
              style="top: 44.3%;left: 72.3%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
              outlined
            />
            <v-text-field
              v-model="form.breastplate_module.d"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schema D"
              :class="{ error: errors.has('(Plastron) Schema D') }"
              outlined
              type="number"
              style="top: 84.9%;left: 56.3%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
            />
            <v-text-field
              v-model="form.breastplate_module.e"
              v-validate="'numeric|max:4'"
              data-vv-name="(Plastron) Schema E"
              :class="{ error: errors.has('(Plastron) Schema E') }"
              type="number"
              style="top: 53.3%;left: 0.2%;"
              height="100%"
              :disabled="!form.breastplate_module.idc_breastplate"
              outlined
            />
          </div>
        </div>
      </v-flex>
      <v-flex sm3>
        <v-radio-group
          v-model="form.breastplate_module.construction_type"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        >
          <v-radio
            label="Gabarit"
            value="TEMPLATE"
          />
          <v-radio
            label="Sur mesures"
            value="CUSTOM_MADE"
          />
        </v-radio-group>
        <v-switch
          v-model="form.breastplate_module.idc_shoulder_socket"
          label="Réhausse épaule"
          hide-details
          :disabled="!form.breastplate_module.idc_breastplate"
        />
        <v-switch
          v-model="form.breastplate_module.idc_adjustment_cebelor"
          label="Réglage Cebelor"
          hide-details
          class="mt-0"
          :disabled="!form.breastplate_module.idc_breastplate"
        />
      </v-flex>
    </v-layout>

    <v-textarea
      v-model="form.breastplate_comments"
      filled
      name="Ajouter un commentaires :"
      label="Ajouter un commentaires :"
      class="mt-8 mb-4"
      rows="2"
      :disabled="!form.breastplate_module.idc_breastplate"
    />

    <v-layout justify-space-between>
      <v-flex sm6>
        <v-switch
          v-model="form.idc_bracket"
          hide-details
          label="Support :"
          class="title"
          @change="clearBracketFields"
        />
        <v-radio-group
          v-model="form.bracket_renew"
          row
          hide-details
          :disabled="!form.idc_bracket"
        >
          <v-layout
            class="checkbox-input-container mb-4"
            align-center
          >
            <v-flex sm6>
              <v-radio
                label="Nouveau"
                value="NEW"
                h
              />
            </v-flex>
          </v-layout>

          <v-layout
            class="checkbox-input-container mb-3"
            align-center
          >
            <v-flex sm6>
              <v-radio
                class="ml-5"
                label="Existant"
                value="EXISTING"
                h
                :disabled="!form.idc_bracket"
              />
            </v-flex>
            <v-flex
              sm6
              class="checkbox-input visible"
            />
          </v-layout>
        </v-radio-group>

        <v-container>
          <v-row>
            <v-col>
              <v-select
                v-model="form.bracket"
                :items="dropdowns.bracket"
                item-text="label"
                item-value="value"
                label="PM"
                filled
                clearable
                hide-details
                :disabled="!form.idc_bracket"
                @click:clear="$nextTick(() => (form.bracket = null))"
              />
            </v-col>
            <v-col>
              <v-select
                v-model="form.bracket_size"
                :items="['T1', 'T2', 'T3']"
                label="Taille"
                filled
                clearable
                hide-details
                :disabled="!form.idc_bracket"
                @click:clear="$nextTick(() => (form.bracket_size = null))"
              />
            </v-col>
          </v-row>
        </v-container>

        <v-radio-group
          v-model="form.bracket_position"
          hide-details
          :disabled="!form.idc_bracket"
        >
          <v-radio
            hide-details
            label="A l'atelier"
            value="WORKSHOP"
          />
          <v-radio
            label="Au centre"
            value="AT_CENTER"
          />
          <v-layout
            class="checkbox-input-container"
            align-center
          >
            <v-flex>
              <v-radio
                label="Autre"
                value="OTHER"
              />
            </v-flex>
            <v-flex
              hide-details
              class="checkbox-input visible"
            >
              <v-text-field
                v-model="form.other"
                label="Autre"
                hide-details
                outlined
                maxlength="15"
                :disabled="
                  form.bracket_position !== 'OTHER' || !form.idc_bracket
                "
              />
            </v-flex>
          </v-layout>
        </v-radio-group>

        <v-text-field
          v-model="form.serial_number"
          label="N° de série"
          hide-details
          outlined
          maxlength="15"
          class="mb-4 mt-4"
          :disabled="!form.idc_bracket"
        />
        <v-layout class="color-select">
          <v-select
            v-model="form.bracket_color_id"
            :items="liftColors"
            item-text="label"
            item-value="id"
            label="Couleur"
            filled
            clearable
            :disabled="!form.idc_bracket"
            @click:clear="$nextTick(() => (form.bracket_color_id = null))"
          />
          <v-flex
            v-if="previewLiftColor"
            class="preview"
            :style="{ 'background-color': previewLiftColor.rgb_code }"
          />
        </v-layout>
      </v-flex>
      <v-flex sm6>
        <h3 class="mb-5">
          FINITION :
        </h3>
        <v-layout class="color-select">
          <v-select
            v-model="form.thermozaic_color_id"
            :items="thermoColors"
            item-text="label"
            item-value="id"
            label="Thermozaïque"
            filled
            clearable
            hide-details
            class="mb-4"
            @click:clear="$nextTick(() => (form.thermozaic_color_id = null))"
          />
          <v-flex
            v-if="previewThermoColor"
            class="preview"
            style="width: 35px; height: 35px"
          >
            <img
              v-if="previewThermoColor.texture == 'TEXTURE'"
              :src="previewThermoColor.image"
              style="width: 100%; height:100%"
              alt
            >
          </v-flex>
          <v-flex
            v-if="previewThermoColor == 'COLOR'"
            class="preview"
            :style="{ 'background-color': '#' + previewThermoColor.rgb_code }"
          />
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LiftStepSix",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      stretchColors: "colors/getSTRETCHType",
      threeDColors: "colors/get3DType",
      plastaColors: "colors/getPLASTAType",
      thermoColors: "colors/getTHERMOType",
      liftColors: "colors/getLIFTType",

      dropdowns: "dropdowns/getLiftOptions",
      breastPlateModule: "dropdowns/getBreastPlateOptions"
    }),

    previewPlastaColor() {
      return this.plastaColors.find(
        color => color.id == this.form.plastazote_color_id
      );
    },

    previewThermoColor() {
      return this.thermoColors.find(
        color => color.id == this.form.thermozaic_color_id
      );
    },

    previewCoverColor() {
      return this.stretchColors.find(
        color => color.id == this.form.cover_color_id
      );
    },

    previewCover2Color() {
      return this.stretchColors.find(
        color => color.id == this.form.cover2_color_id
      );
    },

    preview3DColor() {
      return this.threeDColors.find(
        color => color.id == this.form.three_d_color_id
      );
    },

    previewLiftColor() {
      return this.liftColors.find(
        color => color.id == this.form.bracket_color_id
      );
    }
  },
  async created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear breastplate fields
    clearBreastplateFields() {
      this.form.breastplate_module.breastplate = null;
      this.form.breastplate_module.breastplate_type = null;
      this.form.breastplate_module.size = null;
      this.form.breastplate_module.a = null;
      this.form.breastplate_module.b = null;
      this.form.breastplate_module.c = null;
      this.form.breastplate_module.d = null;
      this.form.breastplate_module.e = null;
      this.form.breastplate_module.construction_type = null;
      this.form.breastplate_module.idc_shoulder_socket = false;
      this.form.breastplate_module.idc_adjustment_cebelor = false;
      this.form.breastplate_comment = null;
    },

    // Clear bracket fields
    clearBracketFields() {
      this.form.bracket_renew = null;
      this.form.bracket = null;
      this.form.bracket_position = null;
      this.form.other = null;
      this.form.serial_number = null;
      this.form.bracket_color_id = null;
      this.form.bracket_comments = null;
    }
  }
};
</script>

<style lang="scss">
.lift-step-six {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 16.7%;
        height: 12.4%;
        @media (max-width: 800px) {
          height: 12.4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
}
</style>
